export class MatchConfig {
  public listenOn: EventTarget = window;
  constructor(init: Partial<MatchConfig>) {
    Object.assign(this, init);
  }
}
